import { render, staticRenderFns } from "./boothPresident.vue?vue&type=template&id=246149a1&scoped=true&"
import script from "./boothPresident.vue?vue&type=script&lang=js&"
export * from "./boothPresident.vue?vue&type=script&lang=js&"
import style0 from "./boothPresident.vue?vue&type=style&index=0&id=246149a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246149a1",
  null
  
)

export default component.exports